<i18n>
{
  "br": {
    "amountRequestedByClient": "Financiamento Requerido: ",
    "commercialValue": "Valor do Imóvel: ",
    "propertyIsDefined": "Imóvel Definido: ",
    "downPayment": "Entrada: ",
    "segment": "Segmento: ",
    "firstPayment": "Primeira Parcela: ",
    "amortizationMethod": "Amortização: ",
    "lastPayment": "Última Parcela: ",
    "propertyType": "Tipo de Imóvel: ",
    "financingAmount": "Monto Financiado: ",
    "disposableIncome": "Renda: ",
    "segmentName": "Segmento: ",
    "prospectAge": "Idade: ",
    "suggestions": "Sugestões"
  },
  "cl": {
    "amountRequestedByClient": "Monto Solicitado: ",
    "commercialValue": "Valor Propiedad: ",
    "propertyIsDefined": "Inmueble definido: ",
    "downPayment": "Pie: ",
    "segment": "Segmento: ",
    "firstPayment": "",
    "amortizationMethod": "",
    "lastPayment": "",
    "propertyType": "Tipo de Propiedad: ",
    "financingAmount": "Monto Financiado: ",
    "suggestions": "Sugerencias"
  },
  "pe": {
    "amountRequestedByClient": "Monto Solicitado: ",
    "commercialValue": "Valor Propiedad: ",
    "propertyIsDefined": "Inmueble definido: ",
    "downPayment": "Cuota Inicial: ",
    "segment": "Segmento: ",
    "firstPayment": "",
    "amortizationMethod": "",
    "lastPayment": "",
    "propertyType": "Tipo de Propiedad: ",
    "financingAmount": "Financiamento Aprovado: ",
    "suggestions": "Sugerencias"
  }
}
</i18n>
<template>
  <div id="prospect-simulations-data">
    <slot name="simulation-header" />
    <div
      v-for="(simulation, i) in simulations"
      :key="simulation._id"
      class="simulation card-item shadowless my-3"
      :class="{ active: extendedSimulation === i }"
      :style="{ '--i': i }">
      <div class="simulation-info">
        <div class="is-flex-direction-row">
          {{ dateToFormatedString(simulation.createdAt, "DD/MM/YY HH:mm") }}
          <span v-if="simulation.hasOffer === false" class="no-offer-tag creditu-tag">{{
            $t("no-offer")
          }}</span>
        </div>
        <div v-for="(value, key) in getOverviewMap(simulation)" :key="key">
          {{ $t(key) }}
          <span :class="key"> {{ value }}</span>
        </div>
        <div>
          <a
            :id="`extend-button-${i}`"
            href="#"
            @click.prevent="extendedSimulation = extendedSimulation === i ? undefined : i">
            <span
              class="fa fa-lg transition-slow"
              :class="extendedSimulation === i ? 'fa-minus-circle' : 'fa-plus-circle'" />
          </a>
        </div>
      </div>
      <div :id="`simulation-details-${i}`" class="simulation-content transition-fast">
        <div class="simulation-details">
          <div class="flex-box-content">
            <div class="sim-row">
              <div
                v-for="(column, columnIndex) in getDetailsMap(simulation)"
                :key="columnIndex"
                class="sim-column">
                <ul>
                  <li v-for="(value, key) in column" :key="key">
                    <h5>{{ $t(key) }}</h5>
                    <span>
                      {{ value }}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="!simulation.hasOffer" class="sim-column mt-2">
              <b-collapse
                :open="false"
                class="card-suggestion py-3"
                animation="slide"
                aria-id="suggestion">
                <template #trigger="props">
                  <div
                    class="card-header"
                    role="button"
                    aria-controls="suggestion"
                    :aria-expanded="props.open">
                    <h6 class="card-header-title is-size-6 has-text-weight-normal py-0">
                      <b-icon class="has-text-primary pr-2" icon="circle-question" />{{ $t('suggestions') }}
                      <a class="card-header-icon p-0">
                        <b-icon :icon="props.open ? 'chevron-down' : 'chevron-up'" />
                      </a>
                    </h6>
                  </div>
                </template>

                <div class="card-content">
                  <div class="content">
                    <ul>
                      <li v-for="(message, key) in simulation.eligibilityMessages" :key="key">
                        <span v-html="message" />
                      </li>
                    </ul>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateToFormatedString } from '@/infrastructure/date';
import { formatNumberByCountry } from '@/infrastructure/format';

export default {
  name: 'SimulationData',
  props: {
    simulations: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      extendedSimulation: undefined,
      country: this.$i18n.locale
    };
  },
  methods: {
    dateToFormatedString: val => dateToFormatedString(val),
    formatNumberByCountry(number, usePrefix = true) {
      return formatNumberByCountry({ number, countryIn: this.country, usePrefix, minDecimals: 2, maxDecimals: 2 });
    },
    getOverviewMap(simulation) {
      if (simulation.hasOffer === true) {
        return {
          amountRequestedByClient: this.formatNumberByCountry(
            simulation.offerResponseWithIPCA
              ? simulation.offerResponseWithIPCA.amountRequestedByClient
              : simulation.offerResponse.amountRequestedByClient
          ),
          financingAmount: this.formatNumberByCountry(simulation.offerResponse.financingAmount)
        };
      }
      const {
        offerInputs: { commercialValue, downPayment, subsidy, disposableIncome }
      } = simulation;
      return {
        amountRequestedByClient: this.formatNumberByCountry(commercialValue - downPayment - subsidy),
        disposableIncome: this.formatNumberByCountry(disposableIncome)
      };
    },
    getSimulationWithOfferMap(simulation) {
      return {
        commercialValue: this.formatNumberByCountry(simulation.offerInputs.commercialValue),
        downPayment: this.formatNumberByCountry(simulation.offerInputs.downPayment),
        amortizationMethod: simulation.amortizationSchedule.amortizationMethod,
        propertyIsDefined: simulation.additionalInfo.propertyIsDefined,
        segment: simulation.offerParams.segment,
        propertyType: simulation.offerInputs.propertyType,
        firstPayment: this.formatNumberByCountry(simulation.amortizationSchedule.firstPayment.monthlyTotal),
        lastPayment: this.formatNumberByCountry(simulation.amortizationSchedule.lastPayment.monthlyTotal)
      };
    },
    getSimulationNoOfferMap(simulation) {
      const {
        offerInputs: {
          commercialValue,
          downPayment,
          disposableIncome,
          employment,
          propertyType,
          segment: { name: segmentName },
          prospectAge,
          eligibilityMessages
        }
      } = simulation;
      return {
        commercialValue: this.formatNumberByCountry(commercialValue),
        downPayment: this.formatNumberByCountry(downPayment),
        disposableIncome: this.formatNumberByCountry(disposableIncome),
        employment,
        propertyType,
        segmentName,
        prospectAge,
        eligibilityMessages
      };
    },
    getDetailsMap(simulation) {
      let map;
      if (simulation.hasOffer === true) {
        map = this.getSimulationWithOfferMap(simulation);
      } else {
        map = this.getSimulationNoOfferMap(simulation);
      }
      return this.organizeInColumns(map);
    },
    organizeInColumns(elements, columnLen = 3) {
      let col = 0;
      return Object.keys(elements).reduce((acIn, el, i) => {
        const ac = JSON.parse(JSON.stringify(acIn));
        if (!ac[col]) {
          ac[col] = {};
        }
        ac[col][el] = elements[el];
        if ((i + 1) % columnLen === 0) {
          col += 1;
        }
        return ac;
      }, []);
    }
  }
};
</script>

<style scoped>
.simulation h5 {
  color: var(--primary);
}
div.simulation-content {
  background: #f9f9f9;
  border-radius: 20px;
  overflow: hidden;
  max-height: 0;
}
div.simulation-info {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
div.simulation-info div {
  margin: 10px;
}
.flex-box-content {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
}
.simulation.active div.simulation-content {
  margin-top: 5px;
  padding: 5px 10px;
  height: fit-content;
  width: -webkit-fill-available;
  overflow-y: auto;
  display: inline-table;
}
.simulation-details {
  width: 100%;
  padding: 0 5px;
  font-size: 0.9rem;
}
.sim-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding: 5px 0;
}
.sim-column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}

.creditu-tag {
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  padding: 0px 10px;
  text-align: center;
}
.no-offer-tag {
  background: var(--primary);
  color: #fff;
}
.card, .card-header {
  box-shadow: none;
}

.card-content{
  padding: 0 5px;
}

.card-suggestion {
  border-radius: 20px;
  background-color: var(--light-grey);
}
</style>
